import React from 'react';
import PropTypes from 'prop-types';
import { useGetImages } from '../../../hooks';
import { getImageData } from '../../../utils';
import LazyImage from '../../LazyImage';

const CarouselImage = ({ imageId, enableLightbox, toggleModal, handleSelectedImage, priority }) => {
  const { data, loading, error } = useGetImages(imageId);

  if (error) return error.message;

  const { url: imageUrl = '', data: imageData = {} } = data.getFile || {
    getFile: { url: '', data: {} }
  };

  const { altText } = getImageData({}, imageData);

  const handleEnableLightbox = () => {
    if (!enableLightbox) return;
    toggleModal();
    handleSelectedImage(imageId);
  };

  return (
    <div className="carousel__slide">
      {loading ? (
        <div />
      ) : (
        <LazyImage
          src={imageUrl}
          alt={altText}
          sizeKey="carousel"
          onClick={handleEnableLightbox}
          role="button"
          aria-label="View Image"
          priority={priority}
        />
      )}
    </div>
  );
};

CarouselImage.propTypes = {
  imageId: PropTypes.string.isRequired,
  enableLightbox: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleSelectedImage: PropTypes.func.isRequired,
  priority: PropTypes.bool.isRequired
};

export default CarouselImage;
